import * as React from 'react';
import classNames from 'classnames';
import './checkBoxSelectInput.module.scss';
import { CheckBoxCardNoBorder } from '../../atoms/select/CheckBoxCardNoBorder';
import _ from 'lodash';

/**
 * セレクターの選択肢一つを表す
 */
export type OptionSpec<T> = {
    /**
     * ユーザに対して表示される選択肢のラベル
     */
    label: string;
    /**
     * 選択肢に対応する値（型は任意）
     */
    value: T;
    /**
     * 選択肢のDOM要素に対して、data-valueとして追加される属性。テストで各選択肢を特定する際に用いる
     */
    valueForAttribute?: string;
};

type Props<T> = {
    id?: string;
    options: OptionSpec<T>[];
    values: T[];
    widthType?: 's' | 'm';
    color: 'white' | 'primary';
    onChange: (values: T[]) => any;
    className?: string;
    styleName?: string;
};
export const CheckBoxSelectInput = <T extends unknown>({
    id,
    options,
    values,
    onChange,
    color = 'white',
    widthType = 'm',
    className,
}: Props<T>) => {
    return (
        <div id={id} styleName={classNames('select-input', widthType)} className={className}>
            {options.map((o) => (
                <CheckBoxCardNoBorder
                    key={String(o.label)}
                    checked={values.some((v) => _.isEqual(v, o.value))}
                    label={o.label}
                    data-value={o.valueForAttribute}
                    color={color}
                    onCheck={(checked) =>
                        onChange(
                            checked
                                ? [...new Set(values.concat(o.value))]
                                : [...new Set(values.filter((v) => !_.isEqual(v, o.value)))]
                        )
                    }
                />
            ))}
        </div>
    );
};
